import { call, put, takeLatest } from "redux-saga/effects";
import candidateTransferService from "../../services/candidateTransfer.service";
import {
  getActiveCompaniesSuccess,
  getActiveCompaniesFailed,
  getSourceJobsSuccess,
  getSourceJobsFailed,
  getSourceStagesSuccess,
  getSourceStagesFailed,
  getDestinationJobsSuccess,
  getDestinationJobsFailed,
  transferCandidateSuccess,
  transferCandidateFailed,
  getTransferHistoriesSuccess,
  getTransferHistoriesFailed,
  deleteTransferHistoriesSuccess,
  deleteTransferHistoriesFailed,
  getTransferHistories,
} from "./candidateTransferSlice";
import { showErrorToaster, showSuccessToaster } from "../../helpers/utils/toaster";

function* fetchActiveCompaniesSaga() {
  try {
    const response = yield call(candidateTransferService.getActiveCompanies);
    if (response.status && response.data) {
      yield put(getActiveCompaniesSuccess(response.data));
    } else {
      yield put(getActiveCompaniesFailed());
    }
  } catch (error) {
    yield put(getActiveCompaniesFailed());
  }
}

function* fetchSourceJobsSaga(action) {
  try {
    const response = yield call(candidateTransferService.getJobsByCompanyId, action.payload);
    if (response.status && response.data) {
      yield put(getSourceJobsSuccess(response.data));
    } else {
      yield put(getSourceJobsFailed());
    }
  } catch (error) {
    yield put(getSourceJobsFailed());
  }
}

function* fetchSourceStagesSaga(action) {
  try {
    const response = yield call(candidateTransferService.getStagesByJobPostId, action.payload);
    if (response.status && response.data) {
      yield put(getSourceStagesSuccess(response.data));
    } else {
      yield put(getSourceStagesFailed());
    }
  } catch (error) {
    yield put(getSourceStagesFailed());
  }
}

function* fetchDestinationJobsSaga(action) {
  try {
    const response = yield call(candidateTransferService.getJobsByCompanyId, action.payload);
    if (response.status && response.data) {
      yield put(getDestinationJobsSuccess(response.data));
    } else {
      yield put(getDestinationJobsFailed());
    }
  } catch (error) {
    yield put(getDestinationJobsFailed());
  }
}

function* transferCandidateSaga(action) {
  try {
    const response = yield call(candidateTransferService.transferCandidate, action.payload);
    if (response.status) {
      yield put(transferCandidateSuccess());
      showSuccessToaster(response.message || "Candidates transferred successfully");
      yield put(getTransferHistories());
    } else {
      yield put(transferCandidateFailed());
      showErrorToaster(response.message || "Transfer failed");
    }
  } catch (error) {
    yield put(transferCandidateFailed());
    showErrorToaster("Something went wrong");
  }
}

function* fetchTransferHistoriesSaga() {
  try {
    const response = yield call(candidateTransferService.getTransferHistories);
    if (response.status && response.data) {
      yield put(getTransferHistoriesSuccess(response.data));
    } else {
      yield put(getTransferHistoriesFailed());
    }
  } catch (error) {
    yield put(getTransferHistoriesFailed());
  }
}

function* deleteTransferHistorySaga(action) {
  try {
    const response = yield call(candidateTransferService.deleteTransferHistories, action.payload);
    if (response.status) {
      yield put(deleteTransferHistoriesSuccess());
      showSuccessToaster(response.message || "History deleted successfully");
      yield put(getTransferHistories());
    } else {
      yield put(deleteTransferHistoriesFailed());
      showErrorToaster(response.message || "Delete failed");
    }
  } catch (error) {
    yield put(deleteTransferHistoriesFailed());
    showErrorToaster("Something went wrong");
  }
}

export default function* candidateTransferSaga() {
  yield takeLatest("candidateTransfer/getActiveCompanies", fetchActiveCompaniesSaga);
  yield takeLatest("candidateTransfer/getSourceJobs", fetchSourceJobsSaga);
  yield takeLatest("candidateTransfer/getSourceStages", fetchSourceStagesSaga);
  yield takeLatest("candidateTransfer/getDestinationJobs", fetchDestinationJobsSaga);
  yield takeLatest("candidateTransfer/transferCandidate", transferCandidateSaga);
  yield takeLatest("candidateTransfer/getTransferHistories", fetchTransferHistoriesSaga);
  yield takeLatest("candidateTransfer/deleteTransferHistories", deleteTransferHistorySaga);
}
